/**
 * Comparator for ally products: ascending by `display_order`, nulls last.
 * Shared by AllyPage and AllyProductsCarousel so both sort identically.
 */
export const byDisplayOrder = (a, b) => {
  const ao = a.display_order;
  const bo = b.display_order;
  if (ao == null && bo == null) return 0;
  if (ao == null) return 1;
  if (bo == null) return -1;
  return ao - bo;
};
